<template>
  <div>
    <StatsLeagueSelection/>

    <DataTable
      v-for="i in [1,2]"
      :key="i"
      :page-size="30"
      resource="goaliestats"
      query="per-phase"
      :field-ids="['curTeamId', 'playerId', 'gp', 'assignments', 'completeGame', 'spare', 'gkOut', 'gkIn', 'toi', 'ga', 'en', 'toiGa', 'ga_60', 'svPct', 'sb', 'st', 'st_60', 'so', 'won', 'loss', 'wonPct', 'lossPct']"
      :query-params="{season: '1819', league: 'a', gameType: 'm', orderBy: 'sv_pct'}"
    />
  </div>
</template>

<script setup lang="ts">
  import DataTable from '@/components/stats/DataTable.vue';
  import StatsLeagueSelection from '@/components/stats/selection/StatsLeagueSelection.vue';
</script>
